import { render } from "./FilterRelatory.vue?vue&type=template&id=d5127bf4&scoped=true&ts=true"
import script from "./FilterRelatory.vue?vue&type=script&lang=ts"
export * from "./FilterRelatory.vue?vue&type=script&lang=ts"

import "./FilterRelatory.vue?vue&type=style&index=0&id=d5127bf4&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5127bf4"]])

export default __exports__